// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from './Home'
import MapPage from './MapPage'
import ChatPage from './ChatPage'

import Example from './Example'

const routes = [
  { path: '/',
    redirect: { path: 'mapPage' }
  },
  // { path: '/login', component: Login },
  { path: '/home', component: Home },
  { path: '/mapPage', component: MapPage },
  { path: '/chatPage', component: ChatPage },

  // { path: '/messages', component: Messages, beforeEnter: guardRoute },
  // { path: '/users', component: Users, beforeEnter: guardRoute },
  // { path: '/chart', component: Chart, beforeEnter: guardRoute },
  { path: '/example', component: Example }
  // { path: '/logout', beforeEnter: function () { auth.logout() } }

]

export default new VueRouter({
  routes
})



// WEBPACK FOOTER //
// ./src/router.js